import { Environment } from '@galaxy/core';

export const GOOGLE_SOURCE_ID = '10010';
export const FACEBOOK_SOURCE_ID = '10050';

export const LOCAL_STORAGE_ID = 'inbox-last-channel-id';
export const CONVERSATION_COOKIE_PREFIX = 'conversation-id-';

export const EXCLUDED_GEOGRAPHICAL_US_STATES = ['AA', 'AE', 'AP', 'AS', 'FM', 'GU', 'MH', 'MP', 'PW', 'VI'];

export const ENABLED_COUNTRIES_FOR_SMS = ['ca', 'us', 'it', 'au', 'gb', 'de', 'cz'];

export const ALPHANUMERIC_SENDER_ID_COUNTRIES = ['it'];

export const DEFAULT_CV_ICON = 'https://vstatic-prod.apigateway.co/business-center-client/assets/cv-logo.png';
export const DEFAULT_CV_NAME = 'Customer Voice';
export const CustomerVoiceAppIDs = {
  [Environment.LOCAL]: 'MP-fba21121b71148c9bb33e11fcd92d520',
  [Environment.TEST]: 'MP-fba21121b71148c9bb33e11fcd92d520',
  [Environment.DEMO]: 'MP-fba21121b71148c9bb33e11fcd92d520',
  [Environment.PROD]: 'MP-c4974d390a044c28aec31e421aa662b2',
};

export const ConversationAIMarketplaceAppIDs = {
  [Environment.LOCAL]: 'MP-PL2GFTX5ZNDDWZD64RCQ5FKMMJQNXRVC',
  [Environment.TEST]: 'MP-PL2GFTX5ZNDDWZD64RCQ5FKMMJQNXRVC',
  [Environment.DEMO]: 'MP-PL2GFTX5ZNDDWZD64RCQ5FKMMJQNXRVC',
  [Environment.PROD]: 'MP-NKC8VH78X2BKWJNPRSLH2TT3JWX83PD3',
};

export const REPLACE_NAME_WITH_PHONE_PLACEHOLDER = '-';

export const INVALID_CONTACT_NAMES = [undefined, null, REPLACE_NAME_WITH_PHONE_PLACEHOLDER, '- -', ''];

// Used as a placeholder / fallback name
export const DEFAULT_OPENAI_BOT_NAME = 'Vendasta AI';

export const CONTACTS_PAGE_SIZE = 5;
export const TEMPLATES_PAGE_SIZE = 20;
export const EMAIL_MESSAGE_BODY_MAX_LENGTH = 300;

// default view id for follow DefaultViewID
export const FOLLOWING_VIEW_ID = 'following';
export const ALL_VIEW_ID = 'all';

// feature flag ids
export const INBOX_PLATFORM_CHAT = 'inbox_platform_chat';
// Gates the AutoDraft AI mode option; mirrors the backend ai_drafter_enabled flag.
export const AI_DRAFTER_ENABLED = 'ai_drafter_enabled';

export const INBOX_ASSIGNED_ONLY = 'inbox_assigned_only';

export const INBOX_DELETE_CONVERSATION = 'inbox_delete_conversation_enabled';

export const INBOX_ONE_ON_ONE = 'inbox_one_on_one';

export const INBOX_SIDE_BAR = 'business_app_conversation_sidebar';

export const VOICE_AI = 'voice_ai';
export const AU_SMS_AND_VOICE = 'au_sms_and_voice';
export const GB_SMS_AND_VOICE = 'gb_sms_and_voice';
export const DE_SMS = 'de_sms';
export const CZ_SMS_AND_VOICE = 'cz_sms_and_voice';
export const SMS_REGULATION_COMPLIANCE_REGISTRATION = 'sms_regulation_compliance_registration';
export const SHOW_GOOGLE_CHAT_INTEGRATION = 'show_googlechat_integration';

// TODO: Use CRM SDK provided constants when available (CRMAAS-355 + MEGA-221)
export const STANDARD_CRM_FIELD_EXTERNAL_IDS = {
  firstName: 'standard__first_name',
  lastName: 'standard__last_name',
  phoneNumber: 'standard__phone_number',
  email: 'standard__email',
  updated: 'system__contact_updated',
  created: 'system__contact_created',
  tags: 'standard__tags',
  source: 'standard__contact_source_name',
};

export type AppOptionsKeys = 'is_multilocation';

export const INBOX_CRM_SOURCE_NAME = 'Conversations';

/**
 * The inbox writes its on/off state to the URL as `?spam=1`; the param is dropped when off.
 * Anything other than this exact value reads as off, so a hand-typed `?spam=true` does nothing.
 */
export const URL_FLAG_ON = '1';

/** The four inbox views. Each string is both the picker's option value and its URL flag name. */
export const INBOX_VIEW = {
  inbox: 'inbox',
  closed: 'closed',
  anonymous: 'anonymous',
  spam: 'spam',
} as const;

export type InboxViewValue = (typeof INBOX_VIEW)[keyof typeof INBOX_VIEW];

/** Filter params that are on or off, the same way the views are. */
export const INBOX_FILTER_FLAG = {
  unread: 'unread',
  needsReply: 'needsReply',
  assignedToMe: 'assignedToMe',
  unassigned: 'unassigned',
} as const;

export type InboxFilterFlagValue = (typeof INBOX_FILTER_FLAG)[keyof typeof INBOX_FILTER_FLAG];

/** Filter params that carry text instead of an on/off flag, so they are read with `params.get` directly. */
export const INBOX_TEXT_PARAM = {
  channels: 'channels',
  search: 'q',
} as const;

/** Only these params are on/off. Naming anything else is a build error rather than a view that silently never opens. */
export type InboxUrlFlag = InboxViewValue | InboxFilterFlagValue;
